import _objectSpread from "/Users/shorlyn/Documents/project/core/campus-all/rccms-web/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _typeof from "/Users/shorlyn/Documents/project/core/campus-all/rccms-web/node_modules/@babel/runtime/helpers/esm/typeof.js";
import _defineProperty from "/Users/shorlyn/Documents/project/core/campus-all/rccms-web/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.reduce.js";
import "core-js/modules/es.number.parse-float.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
/**
 * 弹窗组件
 * @module $ui/components/my-dialog
 */
import MyDrag from '../Drag/Drag';
import MyResize from '../Resize/Resize';
import MySpin from '../Spin/Spin';
import { addResizeListener, removeResizeListener } from 'element-ui/lib/utils/resize-event';
import clickoutside from 'element-ui/lib/utils/clickoutside';
import { addClass, removeClass } from 'element-ui/lib/utils/dom';
import Panel from './Panel';
import SrcFrame from './SrcFrame';
var Z_INDEX = 100;

/**
 * 适配百分比或像素单位
 * @private
 * @param {number} max 最大的长度
 * @param {string} value 要转换的长度值
 * @return {number}
 */
function getLength(max, value) {
  if (!value) return 0;
  var percent = value.includes('%');
  var val = Number.parseFloat(value);
  return percent ? max * val / 100 : val;
}

/**
 * 插槽
 * @member slots
 * @property {string} default 默认插槽，弹窗显示的内容
 * @property {string} icon 定义标题前的图标
 * @property {string} title 定义标题
 * @property {string} tool 定义头部的工具按钮操作区
 * @property {string} footer 定义底部， 定义底部将会导致确定、取消按钮失效
 */
export default {
  name: 'MyDialog',
  components: {
    Panel: Panel,
    MyDrag: MyDrag,
    MyResize: MyResize,
    MySpin: MySpin,
    SrcFrame: SrcFrame
  },
  directives: {
    clickoutside: clickoutside
  },
  /**
   * 属性参数
   * @member props
   * @property {boolean} [visible=true] 显示弹窗，支持sync修饰符
   * @property {string} [title] 标题文本，复杂内容可通过插槽定义
   * @property {string|object} [icon] 标题前的图标，可以是字体图标或svg
   * @property {string} [width] 弹窗宽度
   * @property {string} [height] 高度
   * @property {boolean} [modal] 显示遮罩层
   * @property {string} [theme] 主题风格，可选值：'primary', 'dark', 'light'
   * @property {boolean|object} [draggable] 拖拽配置，参考MyDrag组件
   * @property {boolean|object} [resizable] resize配置，参考MyResize组件
   * @property {string} [animation=el-fade-in] 显示动画
   * @property {boolean} [footer=true] 显示底部
   * @property {string} [submitText=确定] 确定按钮文本
   * @property {string} [cancelText=取消] 取消按钮文本
   * @property {boolean} [submitLoading] 确定按钮显示loading，防止重复提交
   * @property {boolean} [closable=true] 窗体可关闭
   * @property {function} [beforeClose] 窗体关闭前进行的操作，必须要返回Promise
   * @property {boolean} [maximizable] 可最大化
   * @property {boolean} [maximized] 初始是否最大化
   * @property {boolean} [minimizable] 可最小化，最小化只隐藏，不销毁组件
   * @property {boolean} [minimized] 初始是否最小化
   * @property {boolean} [cancelClose] 点击取消按钮关闭窗体
   * @property {boolean} [loading] 显示loading
   * @property {boolean} [loadingTip=正在拼命加载...] loading提示文本
   * @property {string} [src] 用iframe加载的页面地址
   * @property {string} [bodyClass] dialog内容容器className
   * @property {string} [target] 窗体加载到容器的html选择器
   * @property {boolean} [closeOnClickOutside] 点击窗体外部关闭
   */
  props: {
    // 显示
    visible: {
      type: Boolean,
      default: true
    },
    title: {
      type: String,
      default: ''
    },
    icon: [String, Object],
    width: String,
    height: String,
    modal: Boolean,
    theme: {
      type: String,
      default: 'light',
      validator: function validator(val) {
        return ['primary', 'dark', 'light'].includes(val);
      }
    },
    draggable: [Boolean, Object],
    resizable: [Boolean, Object],
    animation: {
      type: String,
      default: 'el-fade-in'
    },
    footer: {
      type: Boolean,
      default: true
    },
    submitText: {
      type: String,
      default: '确定'
    },
    submitVisible: Boolean,
    submitLoading: Boolean,
    cancelText: {
      type: String,
      default: '取消'
    },
    closable: {
      type: Boolean,
      default: true
    },
    beforeClose: Function,
    maximizable: Boolean,
    maximized: Boolean,
    minimizable: Boolean,
    minimized: Boolean,
    cancelClose: {
      type: Boolean,
      default: true
    },
    loading: Boolean,
    loadingTip: {
      type: String,
      default: '正在拼命加载...'
    },
    src: String,
    bodyClass: String,
    // 窗体加载到容器的html选择器
    target: String,
    closeOnClickOutside: Boolean
  },
  data: function data() {
    return {
      currentVisible: this.visible,
      viewWidth: 0,
      viewHeight: 0,
      viewLeft: 0,
      viewTop: 0,
      originalWidth: 0,
      originalHeight: 0,
      dialogWidth: 0,
      dialogHeight: 0,
      zIndex: ++Z_INDEX,
      // Z_INDEX,
      currentMaximized: this.maximized,
      currentMinimized: false
    };
  },
  computed: {
    wrapperStyle: function wrapperStyle() {
      return {
        zIndex: this.zIndex,
        left: "".concat(this.viewLeft, "px"),
        top: "".concat(this.viewTop, "px")
      };
    },
    dialogClass: function dialogClass() {
      return _defineProperty({
        'my-dialog': true,
        'my-dialog--src': this.src
      }, this.bodyClass, !!this.bodyClass);
    },
    dialogStyle: function dialogStyle() {
      var left = Math.max((this.viewWidth - this.originalWidth) / 2, 0);
      var top = Math.max((this.viewHeight - this.originalHeight) / 2, 0);
      return {
        left: "".concat(left, "px"),
        top: "".concat(top, "px")
      };
    },
    iconOptions: function iconOptions() {
      if (!this.icon) return null;
      return _typeof(this.icon) === 'object' ? _objectSpread({}, this.icon) : {
        name: this.icon
      };
    },
    resizeOptions: function resizeOptions() {
      return _objectSpread(_objectSpread({
        minWidth: 300,
        minHeight: 150,
        maxWidth: this.viewWidth,
        maxHeight: this.viewHeight
      }, this.resizable || {}), {}, {
        disabled: this.currentMaximized ? true : !this.resizable
      });
    },
    dragOptions: function dragOptions() {
      var _this = this;
      return _objectSpread({
        handle: function handle() {
          if (_this.$refs.panel) {
            if (_this.$refs.panel.$refs.header) {
              return _this.$refs.panel.$refs.header;
            }
            return _this.$refs.panel;
          }
          return null;
        },
        range: function range() {
          return {
            left: -_this.dialogWidth + 10,
            top: 0,
            width: _this.viewWidth + _this.dialogWidth - 20,
            height: _this.viewHeight - 10
          };
        },
        disabled: this.currentMaximized ? true : !this.draggable
      }, this.draggable);
    }
  },
  watch: {
    width: function width() {
      var _this2 = this;
      this.$nextTick(function () {
        _this2.updateView();
      });
    },
    height: function height() {
      var _this3 = this;
      this.$nextTick(function () {
        _this3.updateView();
      });
    },
    visible: function visible(val) {
      this.currentVisible = val;
      // 如果不可见，最小化已经无意义，需要重置
      if (!val) {
        this.currentMinimized = false;
      }
    },
    currentVisible: function currentVisible(val) {
      this.dispose();
      if (val) {
        this.zIndex = ++Z_INDEX;
        this.$nextTick(this.init);
      }
    },
    maximized: {
      immediate: true,
      handler: function handler(val) {
        this.maximizable && (this.currentMaximized = val);
      }
    },
    currentMaximized: function currentMaximized(val) {
      var _this4 = this;
      if (!this.currentVisible) return;
      /**
       * 最大化变化时触发
       * @event maximize
       * @param {boolean} 是否最大化
       */
      this.$emit('maximize', val);
      this.$nextTick(function () {
        _this4.maximize(val);
      });
    },
    minimized: {
      immediate: true,
      handler: function handler(val) {
        this.minimizable && (this.currentMinimized = val);
      }
    },
    currentMinimized: function currentMinimized(val) {
      var _this5 = this;
      // 如果组件不可见，最小化失效
      if (!this.currentVisible) return;
      this.$nextTick(function () {
        val ? _this5.hide() : _this5.show();
        _this5.setBodyHidden(!val);
      });
    }
  },
  mounted: function mounted() {
    this.currentVisible && this.init();
  },
  beforeDestroy: function beforeDestroy() {
    this.dispose();
  },
  methods: {
    init: function init() {
      if (!this.$el || this.$el.nodeType !== 1) return;
      if (this.target) {
        this.targetDOM = document.querySelector(this.target);
        this.targetDOM && this.targetDOM.appendChild(this.$el);
      }
      if (this.$el.parentNode) {
        addResizeListener(this.$el.parentNode, this.updateView);
      }
      if (!this.draggable && !this.resizable) {
        addResizeListener(this.$el, this.updateView);
      }
      this.updateView();
      /**
       * 窗体打开时触发
       * @event open
       */
      this.$emit('open');
      this.setBodyHidden(true);
    },
    dispose: function dispose() {
      if (this.$el && this.$el.parentNode) {
        removeResizeListener(this.$el.parentNode, this.updateView);
        if (this.target) {
          this.$el.parentNode.removeChild(this.$el);
        }
      }
      if (!this.draggable && !this.resizable) {
        removeResizeListener(this.$el, this.updateView);
      }
      this.setBodyHidden(false);
      this.dialogWidth = null;
      this.dialogHeight = null;
      this.currentMinimized = this.minimized;
      this.currentMaximized = this.maximized;
      this.targetDOM = null;
      this.$emit('dispose');
    },
    updateView: function updateView() {
      if (!this.$el || !this.$refs.dialog) return;
      var rect = this.$el.getBoundingClientRect();
      this.viewHeight = rect.height;
      this.viewWidth = rect.width;
      this.viewLeft = Math.max(document.documentElement.scrollLeft, document.body.scrollLeft);
      this.viewTop = Math.max(document.documentElement.scrollTop, document.body.scrollTop);
      if (this.currentMaximized) {
        this.maximize(true);
      }
      if (!this.dialogWidth || !this.dialogHeight) {
        var dialogRect = this.$refs.dialog.$el.getBoundingClientRect();
        this.originalWidth = this.dialogWidth = getLength(this.viewWidth, this.width) || dialogRect.width;
        this.originalHeight = this.dialogHeight = getLength(this.viewHeight, this.height) || dialogRect.height;
      }
    },
    // 重置窗体宽高方法：参数为
    redoLayout: function redoLayout() {
      var _this6 = this;
      var opt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        width: null,
        height: null
      };
      var hHeight = this.$refs.panel.headerHeight;
      var fHeight = this.$refs.panel.footerHeight;
      var innerNodes = this.$slots.default;
      var innerNodeHeight = innerNodes.reduce(function (total, node) {
        var nodeHeight = node.elm.offsetHeight || 0;
        total += nodeHeight;
        return total;
      }, 0);
      var newDialogHeight = innerNodeHeight + hHeight + fHeight + 24;
      var resizeObj = {
        height: opt.h || newDialogHeight,
        width: opt.w
      };
      this.$nextTick(function () {
        _this6.originalHeight = resizeObj.height || _this6.dialogHeight;
        _this6.originalWidth = resizeObj.width || _this6.dialogWidth;
        _this6.handleResize(resizeObj);
      });
    },
    handleResizeStart: function handleResizeStart(e) {
      /**
       * 开始改变尺寸时触发
       * @event resize-start
       * @param {Object} e
       */
      this.$emit('resize-start', e);
    },
    handleResizeStop: function handleResizeStop(e) {
      /**
       * 停止改变尺寸时触发
       * @event resize-stop
       * @param {Object} e
       */
      this.$emit('resize-stop', e);
    },
    handleResize: function handleResize(e) {
      var width = e.width,
        height = e.height;
      this.dialogWidth = width || this.dialogWidth;
      this.dialogHeight = height || this.dialogHeight;
      /**
       * 改变尺寸时触发
       * @event resize
       * @param {Object} e
       */
      this.$emit('resize', e);
    },
    handleDragStart: function handleDragStart(e) {
      /**
       * 开始拖拽时触发
       * @event drag-start
       * @param {Object} e
       */
      this.$emit('drag-start', e);
    },
    handleDrag: function handleDrag(e) {
      /**
       * 拖拽时触发
       * @event drag
       * @param {Object} e
       */
      this.$emit('drag', e);
    },
    handleDragStop: function handleDragStop(e) {
      /**
       * 停止拖拽时触发
       * @event drag-stop
       * @param {Object} e
       */
      this.$emit('drag-stop', e);
    },
    handleMousedown: function handleMousedown() {
      this.zIndex = ++Z_INDEX;
    },
    handleClickOutside: function handleClickOutside() {
      if (this.closeOnClickOutside) {
        this.handleClose();
      }
    },
    handleClose: function handleClose() {
      this.currentVisible = false;
      this.$emit('update:visible', false);
      /**
       * 窗体关闭时触发
       * @event close
       */
      this.$emit('close');
    },
    handleSubmit: function handleSubmit() {
      /**
       * 点击确定按钮时触发
       * @event submit
       */
      this.$emit('submit');
    },
    handleCancel: function handleCancel() {
      /**
       * 点击取消按钮时触发
       * @event cancel
       */
      this.$emit('cancel');
      if (this.cancelClose) {
        this.handleClose();
      }
    },
    handleSrcLoad: function handleSrcLoad() {
      /**
       * iframe完成加载内容时触发
       * @event load
       */
      this.$emit('load');
    },
    maximize: function maximize(maximized) {
      if (maximized) {
        // 记录全屏之前的窗口尺寸
        if (!this.sizeCaches) {
          this.sizeCaches = {
            dialogWidth: this.dialogWidth,
            dialogHeight: this.dialogHeight
          };
        }
        this.originalWidth = this.dialogWidth = this.viewWidth;
        this.originalHeight = this.dialogHeight = this.viewHeight;
      } else {
        if (this.sizeCaches) {
          var _this$sizeCaches = this.sizeCaches,
            dialogWidth = _this$sizeCaches.dialogWidth,
            dialogHeight = _this$sizeCaches.dialogHeight;
          this.originalWidth = this.dialogWidth = dialogWidth;
          this.originalHeight = this.dialogHeight = dialogHeight;
        }
      }
      if (this.resizable) {
        this.$refs.resize.width = this.originalWidth;
        this.$refs.resize.height = this.originalHeight;
      }
    },
    show: function show() {
      this.zIndex = ++Z_INDEX;
      this.currentMinimized = false;
      /**
       * 显示时触发
       * @event show
       */
      this.$emit('show');
    },
    hide: function hide() {
      this.currentMinimized = true;
      /**
       * 隐藏时触发
       * @event hide
       */
      this.$emit('hide');
    },
    setBodyHidden: function setBodyHidden(hidden) {
      var name = 'my-dialog-hidden-' + this._uid;
      var targetDom = this.targetDOM || this.$el.parentNode;
      hidden ? addClass(targetDom, name) : removeClass(targetDom, name);
    }
  }
};